import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserController from "../../../../services/system/user/user-controller";
import CustomerGroupController from "../../../../services/qlts/admissions/customer-group-controller";

class modalCreateAdmissionsGroupUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            description: '',
        };
    }

    createCustomerGroup = () => {
        let payload = {
            "name": this.state.name,
            "description": this.state.description
        }
        CustomerGroupController.createCustomerGroup(payload, res => {
            if (res.success) {
                toast.success("Thêm nhóm khách hàng thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.warning(res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm mới nhóm khách hàng</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên nhóm khách hàng(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="QC Times"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.name}
                                        onChange={(event) => {
                                            this.setState({
                                                name: event.target.value
                                            })
                                        }}
                                    />
                                </div>

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Mô tả nhóm</label>
                                    <input
                                        placeholder="Nam/Nữ: 30-60 Tuổi"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.description}
                                        onChange={(event) => {
                                            this.setState({
                                                description: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createCustomerGroup()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default modalCreateAdmissionsGroupUser
